export type CollectionCreatorBadgeInput = {
    creatorDisplayName?: string
    creatorIsAdmin?: boolean
}

export type CollectionCreatorBadgeCopy = {
    text: string
    title: string
    isLabwickAdmin?: boolean
    isUnknownUser?: boolean
}

function isUnknownCreatorName(name: string): boolean {
    return name.trim().toLowerCase() === "unknown user"
}

export function getCollectionCreatorBadgeCopy(
    component: CollectionCreatorBadgeInput
): CollectionCreatorBadgeCopy | null {
    if (!component.creatorDisplayName) return null
    if (component.creatorIsAdmin) {
        const name = component.creatorDisplayName.trim()
        return {
            text: "By labwick admin",
            title: name ? `Created by ${name} (Labwick Admin)` : "Created by Labwick Admin",
            isLabwickAdmin: true,
        }
    }
    const name = component.creatorDisplayName
    if (isUnknownCreatorName(name)) {
        return { text: "", title: "Unknown user", isUnknownUser: true }
    }
    return { text: `By ${name}`, title: `By ${name}` }
}
